import { render, staticRenderFns } from "./SoldParts.vue?vue&type=template&id=0a557848"
import script from "./SoldParts.vue?vue&type=script&lang=ts"
export * from "./SoldParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports